import { render, staticRenderFns } from "./info-list.vue?vue&type=template&id=7dc7d112"
import script from "./info-list.vue?vue&type=script&lang=js"
export * from "./info-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports